import 'css-chunksrc/client/pages/capacityPage/toolbar/styles.scss';export default {
  "toolbar": "_toolbar_1r8sc_1",
  "filter": "_filter_1r8sc_10",
  "title": "_title_1r8sc_16"
};